'use client';
import Request from '@/app/_components/ui/icons/Request.svg';
import Back from '@/app/_components/ui/icons/Back.svg';
import Image from 'next/image';
import React, { useState } from 'react';
import { expertsData } from '@/app/_libs/utils/constants/expertsData';
import Icon from '../ui/Icon';
import { useContactUsUser } from '@/app/_hooks/useContactUsUser';
import Link from 'next/link';
import { useChatContext } from '@/app/_providers/ChatContext';
import WhatsAppUserForm from './WhatsAppUserForm';
import WhatsAppGreenV2 from '@/app/_components/ui/icons/WhatsAppGreenV2.svg';

function ChatWithSupport() {
  const updateContactUsUser = useContactUsUser();
  const [currentStep, setCurrentStep] = useState('first-page');
  const [selectedExpert, setSelectedExpert] = useState(undefined);
  const { isOpen, setIsOpen } = useChatContext();

  // Store selected expert for connect.
  const setExpert = (expert) => {
    setSelectedExpert(expert);
    setCurrentStep('contact-information');
  };

  // Connect user to selected expert.
  const connectToExpert = async (values) => {
    updateContactUsUser.mutate(
      {
        ...values,
        advisor_name: selectedExpert?.name,
        advisor_phone: selectedExpert?.phone,
        advisor_category: selectedExpert?.category,
      },
      {
        onSuccess: () => {
          if (selectedExpert) {
            window.open(
              `${selectedExpert.whatsapp_link}`,
              '_blank',
              'noreferrer'
            );
          }
        },
      }
    );
  };

  return (
    <div
      className={`fixed inline-block md:bottom-7 md:right-7 z-30 bg-white shadow-sm transition-all duration-200 ${
        isOpen
          ? `xs:w-full  bottom-0 right-0 h-full max-h-full  md:h-[39.5rem] sm:w-[360px] md:rounded-2xl  overflow-y-auto`
          : `xs:w-12 xs:h-12 right-7 bottom-7 lg:w-14 lg:h-14 rounded-full cursor-pointer`
      }`}
    >
      {isOpen ? (
        <div className="">
          {currentStep === 'first-page' ? (
            <div className="w-full h-56 bg-gradient-to-r from-light-blue-300 to-color-primary rounded-b-2xl">
              <div className="flex justify-between items-center p-5">
                <span
                  onClick={() => setIsOpen(false)}
                  className=" cursor-pointer p-1 rounded-full text-white hover:bg-blue-700  transition-all duration-200"
                >
                  <Icon name="Close_v2" />
                </span>
                <span className="w-1/3">
                  <Image
                    src={'/images/popup-logo.png'}
                    width={107}
                    height={34}
                    alt={'فروشگاه برقچی'}
                  />
                </span>
              </div>

              <div className="p-7 text-sm space-y-2 font-medium text-white">
                <p>از ساعت 9 تا 18 در روزهای کاری پاسخگوی شما هستیم</p>
                <p>
                  <span>شماره تماس :</span>
                  <a href="tel:+982135000020">35000020-021</a>
                </p>
              </div>

              <div className="-mt-8">
                <div className="p-7 flex flex-col justify-center items-center gap-3">
                  <div className="bg-white rounded-lg shadow-sm px-4 py-5 w-full text-sm flex flex-col justify-start items-start">
                    <h4 className="font-bold my-1">
                      استعلام قیمت برای شرکت و همکاران
                    </h4>
                    <p className="font-medium opacity-50 mb-5">
                      ارسال لیست کالاها جهت اعلام قیمت
                    </p>
                    <Link href="/page/enquiry" className="mr-auto">
                      <div className="inline-flex  justify-center items-center gap-1 self-end font-semibold text-xs px-3 py-2 rounded-3xl cursor-pointer border-2 border-color-primary text-color-primary hover:bg-color-primary hover:text-white transition-all duration-200">
                        <span className="">
                          <Request />
                        </span>
                        <span>درخواست پیش فاکتور</span>
                      </div>
                    </Link>
                  </div>
                  {/* chat with experts */}
                  <div className="bg-white rounded-lg shadow-sm px-4 py-5   w-full text-sm flex flex-col justify-start items-start">
                    <h4 className="font-bold my-1">
                      ارتباط با کارشناسان برقچی
                    </h4>
                    <p className="font-medium opacity-50 mb-3">
                      پاسخگوی سوالات شما هستیم
                    </p>
                    <div>
                      {expertsData.map((expert) => {
                        return (
                          <span key={expert.id} className="mx-1 ">
                            <Image
                              src={expert.profile_photo}
                              width={40}
                              height={40}
                              className="rounded-full"
                              alt={`barghchi expert`}
                            />
                          </span>
                        );
                      })}

                      <span className="mx-1 ">
                        <Image
                          src={'/images/person-10.jpg'}
                          width={40}
                          height={40}
                          className="rounded-full"
                        />
                      </span>
                    </div>
                    <div
                      onClick={() => setCurrentStep('list-of-experts')}
                      className="inline-flex justify-center items-center mt-2 gap-4 self-end font-semibold text-xs px-3 py-2 rounded-3xl cursor-pointer border-2 bg-color-primary text-white"
                    >
                      <span>
                        <WhatsAppGreenV2 />
                      </span>
                      <span>گفتگو با کارشناسان</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {currentStep === 'list-of-experts' ? (
                // List of experts section
                <div>
                  <div className="w-full h-28 bg-gradient-to-r from-light-blue-300 to-blue-700 rounded-b-2xl">
                    {/* back and exit icon */}
                    <div className="flex justify-between items-center p-5">
                      <span
                        onClick={() => setIsOpen(false)}
                        className=" cursor-pointer p-1 rounded-full text-white hover:bg-light-blue-300  transition-all duration-200"
                      >
                        <Icon name="Close_v2" />
                      </span>
                      <span
                        className=" cursor-pointer p-1 rounded-full text-white hover:bg-light-blue-300  transition-all duration-200"
                        onClick={() => setCurrentStep('first-page')}
                      >
                        <Back />
                      </span>
                    </div>
                    <div className="flex flex-col justify-start items-center gap-4 p-5">
                      {expertsData.map((expert) => {
                        return (
                          <div
                            key={expert.id}
                            className="bg-white w-full p-3 rounded-xl shadow-sm text-sm"
                          >
                            <h4 className="font-bold">{expert.name}</h4>
                            <p className="font-semibold text-xs opacity-50 mb-2">
                              <span>{expert.job_title}</span>
                              {expert.internal_number && (
                                <span>
                                  {'- داخلی'}
                                  {expert.internal_number}
                                </span>
                              )}
                            </p>
                            <div className="flex justify-start items-start gap-3">
                              <Image
                                src={expert.profile_photo}
                                width={40}
                                height={40}
                                className="rounded-full"
                                alt={`barghchi expert`}
                              />
                              <div
                                onClick={() => setExpert(expert)}
                                className="inline-flex justify-center items-center gap-2 self-end font-semibold text-xs px-2 py-1 rounded-3xl cursor-pointer bg-light-gray-150 text-black hover:text-green-heavy transition-all duration-200"
                              >
                                <WhatsAppGreenV2 />
                                <span>گفتگو با کارشناسان</span>
                                <span>
                                  <Icon name="CaretLeftV2" />
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {currentStep === 'contact-information' ? (
                    // Contact information section
                    <div>
                      <div className="w-full h-32 bg-gradient-to-r from-light-blue-300 to-blue-700 rounded-b-2xl">
                        {/* back and exit icon */}
                        <div className="flex justify-between items-center p-5">
                          <span
                            onClick={() => setIsOpen(false)}
                            className=" cursor-pointer p-1 rounded-full text-white hover:bg-light-blue-300  transition-all duration-200"
                          >
                            <Icon name="Close_v2" />
                          </span>
                          <span
                            className=" cursor-pointer p-1 rounded-full text-white hover:bg-light-blue-300  transition-all duration-200"
                            onClick={() => setCurrentStep('list-of-experts')}
                          >
                            <Back />
                          </span>
                        </div>
                        <div className="flex flex-col justify-start items-start gap-4 p-5 bg-white shadow-sm m-7 rounded-xl">
                          <h2 className="text-sm font-semibold">
                            اطلاعات تماس
                          </h2>
                          <p className="text-xs font-medium opacity-50">
                            برای ارتباط با کارشناس، لطفا اطلاعات خود را وارد
                            کنید.
                          </p>
                          <WhatsAppUserForm onSubmit={connectToExpert} />
                        </div>
                      </div>
                    </div>
                  ) : null}
                </>
              )}
            </>
          )}
        </div>
      ) : (
        // Whatsapp logo
        <div className="relative" onClick={() => setIsOpen(true)}>
          <span>
            <Image
              src={'/images/social-icons/whatsapp.png'}
              width={90}
              height={90}
              className="object-cover z-30"
              alt="whatsapp icon"
            />
          </span>
          <span className="bg-light-gray-250 animate-slowPing right-0 top-0 rounded-full absolute xs:w-12 xs:h-12  lg:w-14 lg:h-14 z-0"></span>
        </div>
      )}
    </div>
  );
}

export default ChatWithSupport;
